<template>
  <div class="footer">
    <div class="foot-content flex_align_between">
      <div class="message">
        <p class="p1 project">
          <span
            v-for="(item, index) in info.project"
            :key="index"
            @click="toProject(item.id)"
            >{{ item.title }}</span
          >
        </p>
        <p class="p2">
          公司座机：<span>{{ info.landline }}</span
          >咨询电话：<span>{{ info.consult_phone }}</span>
        </p>
        <p class="p1">微信公众号：{{ info.wx_account }}</p>
        <p class="p1">邮箱地址：{{ info.email }}</p>
        <p class="p1" v-html="info.copyright">
            
        </p>
      </div>
      <div class="ewm">
        <div class="img"><img :src="info.wx_qrcode" alt="" /></div>
        <p>关注领取福利</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$myAjax("student/common/bottom", "get", {}, (data) => {
        this.info = data;
      });
    },
    toProject(id) {
      this.$router.push({
        path: "/projectDetails/" + id,
      });
    },
  },
};
</script>
<style lang="scss">
.footer {
  .foot-content {
    .message {
      .p1 {
        a{
            color: unset;
            text-decoration: underline;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.footer {
  background: url("~@/assets/img/foot_bg.png");
  height: 3rem;
  width: 100%;
  padding-top: 0.4rem;
  .foot-content {
    width: 80%;
    margin: 0 auto;
    .message {
      .p1 {
        color: #768aa8;
        font-size: 15px;
        margin-bottom: 0.2rem;
        a{
            color: unset;
            text-decoration: underline;
        }
      }
      .project {
        span {
          padding-right: 10px;
          position: relative;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            top: 4px;
            bottom: 2px;
            right: 5px;
            width: 1px;
            background: #768aa8;
          }
          &:last-child::after {
            display: none;
          }
        }
      }
      .p2 {
        color: #768aa8;
        font-size: 15px;
        margin-bottom: 0.2rem;
        span {
          font-size: 25px;
          color: #768aa8;
          font-weight: 500;
          margin-right: 20px;
        }
      }
    }
    .ewm {
      .img {
        width: 1rem;
        height: 1rem;
        background: #fff;
      }
      p {
        color: #768aa8;
        width: 1rem;
        text-align: center;
        margin-top: 0.1rem;
      }
    }
  }
}
</style>
